import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import crypto from 'crypto';
import { v4 as uuidv4 } from 'uuid';
import Navigation from 'components/Navigation';
import Header from 'components/Header';
import Team from 'components/Team';
import WhyInvest from 'components/WhyInvest';
import Solution from 'components/Solution';
import Popup from 'components/Popup';
import { addLog } from 'utils/logs';
import { useEffect, useRef } from 'react';
function generateUniqueId(email, project_id) {
    var hash = crypto.createHash('md5').update("agent=".concat(window.navigator.userAgent, "&email=").concat(email || uuidv4(), "&project_id=").concat(project_id)).digest('hex');
    return hash;
}
export default function LandingPage(_a) {
    var project = _a.project, actions = _a.actions;
    var queryParams = new URLSearchParams(window.location.search);
    var email = queryParams.get('email') || '';
    var telemetryInitializedRef = useRef(false);
    useEffect(function () {
        if (!project.id || telemetryInitializedRef.current) {
            return;
        }
        telemetryInitializedRef.current = true;
        actions.setTelemetryCustom({ project_id: project.id });
        actions.setTelemetryLabels({
            fingerprint: generateUniqueId(email, project.id),
            plugins: Array.from(navigator.plugins || []).map(function (plugin) { return plugin.name; }).join(', '),
            screenResolution: "".concat(window.screen.width, "x").concat(window.screen.height),
            languages: Array.from(navigator.languages || []).join(', '),
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        });
        if (email) {
            actions.setTelemetryUser({ email: email });
        }
        addLog('Application start', 'custom');
    }, [project.id, email]);
    return (_jsxs(_Fragment, { children: [_jsx(Navigation, { project: project }), _jsx(Header, { project: project }), _jsx(Team, { project: project }), _jsx(WhyInvest, { project: project }), _jsx(Solution, { project: project }), _jsx(Popup, { project: project })] }));
}
